import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {RepresentativeNotesPage} from "./-page/representative-notes.page";
import {RepresentativeNotesPending} from "./-page/representative-notes.pending";
import {representativeNotesSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/representatives/$representativeId/notes/")({
  component: RouteComponent,
  pendingComponent: RepresentativeNotesPending,
  staticData: {meta: {labelDescriptor: routeMessages.notes}},
  validateSearch: (search) => representativeNotesSearchSchema.parse(search),
});

function RouteComponent() {
  const {representativeId} = useParams({strict: false}) as {representativeId: string};
  const {includeDeleted} = Route.useSearch();

  return (
    <RepresentativeNotesPage includeDeleted={includeDeleted} representativeId={representativeId} />
  );
}
